import banner from "../../../Assets/Compliance Certifictes/banner.png";
import React from "react";

const RohsHeader = () => {
  return (
    <div className="w-full h-auto relative">
      <img
        src={banner}
        alt="ISO Certification Banner"
        className="object-cover w-full h-40 sm:h-48 md:h-52 lg:h-full"
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <p className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium">
          RoHS
        </p>
      </div>
    </div>
  );
};

export default RohsHeader;
